import moment from "moment-timezone";
import { convertDateToTimeZone } from "../../../utils/helpers";

// Semi-monthly pay-period boundary helpers (Care Circle timezone).
//
// Canonical boundary rule across layers: compute the period in the Care Circle's
// local time first, then convert to UTC. Authoritative implementations:
//   - frontend: resolveSemiMonthlyPeriodInTimezone(...) (below)
//   - NestJS:   ShiftService.resolveSemiMonthlyPeriod(...)
//   - SQL:      sp_generate_timesheets (SEMI_MONTHLY branch)
// timesheetTopicsToPayrollPeriods(...) is display-only: it derives dropdown
// periods from actual Timesheet topics, supporting both legacy bi-weekly and
// semi-monthly Timesheets without recomputing boundaries.

export const timesheetTopicsToPayrollPeriods = (timesheetTopics, timezone) => {
  if (!Array.isArray(timesheetTopics)) return [];
  let periods = [];

  for (let i = 0; i < timesheetTopics.length; i++) {
    const id = timesheetTopics[i].id;
    const start = convertDateToTimeZone(timesheetTopics[i].startTime, timezone);
    const end = convertDateToTimeZone(timesheetTopics[i].endTime, timezone);
    const placeholder = `${start.toDateString()} –  ${end.toDateString()}`;
    const periodKey =
      Number(id) === -1 ? "-1" : `${start.getTime()}|${end.getTime()}`;

    const existing = periods.find(p => p.name === periodKey);
    if (existing) {
      if (!existing.timesheetIds) {
        existing.timesheetIds = [id];
      } else {
        existing.timesheetIds.push(id);
      }
    } else {
      periods.push({
        name: periodKey,
        start,
        end,
        placeholder,
        timesheetIds: [id]
      });
    }
  }

  return periods.sort((a, b) => a.start - b.start);
};

export const resolveSemiMonthlyPeriodInTimezone = (referenceDate, timezone) => {
  const local = timezone
    ? moment(referenceDate).tz(timezone)
    : moment(referenceDate);
  const inFirstHalf = local.date() <= 15;
  const startLocal = inFirstHalf
    ? local
        .clone()
        .startOf("month")
        .hour(0)
        .minute(0)
        .second(0)
        .millisecond(0)
    : local
        .clone()
        .date(16)
        .hour(0)
        .minute(0)
        .second(0)
        .millisecond(0);
  const endLocal = inFirstHalf
    ? local
        .clone()
        .date(15)
        .hour(23)
        .minute(59)
        .second(59)
        .millisecond(0)
    : local
        .clone()
        .endOf("month")
        .hour(23)
        .minute(59)
        .second(59)
        .millisecond(0);

  return {
    start: startLocal
      .clone()
      .utc()
      .toDate(),
    end: endLocal
      .clone()
      .utc()
      .toDate(),
    startLocal: startLocal.toDate(),
    endLocal: endLocal.toDate()
  };
};
